<template>
  <div>      
    <div class="alert alert-danger  infoMessage" role="alert" v-show='showErrorMessage' > {{ errorMessage }}</div>
    <div class="alert alert-success infoMessage" role="alert" v-show='showSuccessMessage' > {{ successMessage }}</div>
  </div>
</template>

<script>
import { eventBus } from '../../main';

export default {  
  data: function () {     
    return {
        showErrorMessage: false,
        errorMessage: '',
        showSuccessMessage: false,
        successMessage: ''
    }
  },
  created: function () {        
        eventBus.$on('errorMsg', response =>{
            this.errorMsg(response);
        });

        eventBus.$on('resultMessage', response =>{
            this.resultMessage(response);
        });

        eventBus.$on('genericMessage', (code,message) =>{
            this.genericMessage(code,message);
        });

        eventBus.$on('hide', () =>{
            this.hide();
        });
  },
  mounted: function () {        
       
  },
  methods: {
     errorMsg: function(response){
        if(response.body == null) {
            this.gotData = false;
            this.errorMessage = 'No se pudo comunicar con el servidor!!';
            this.showErrorMessage = true;     
            this.showSuccessMessage = false; 

            this.MessageShowTimeOut();                              
        }
    },
    resultMessage: function(response){
        if(response.body.Status != '0') {                                                        
            this.successMessage = 'Cambios guardados satisfactoriamente';                
            this.showErrorMessage = false;
            this.showSuccessMessage = true; 
        }
        else {                                
            this.errorMessage = 'No se pudo guardar los cambios';
            this.showErrorMessage = true;      
            this.showSuccessMessage = false;          
        }

        this.MessageShowTimeOut();
        
    },
    hide: function(){
        this.showErrorMessage = false;
        this.showSuccessMessage = false; 
    },
    genericMessage: function(code, message){

        if(code == 1){
            this.successMessage     = message; 
            this.showErrorMessage   = false;
            this.showSuccessMessage = true;             
        }else{
            this.errorMessage       = message;
            this.showErrorMessage   = true;      
            this.showSuccessMessage = false;                
        }
        this.MessageShowTimeOut();

    },
    MessageShowTimeOut: function()
    {
        setTimeout(() => { 
            this.hide();
        }, 3000);
    }

  },
  filters: {
     
  },
  computed: {
    
  }
}
</script>

<style scoped>
   .infoMessage{       
       text-align: center;       
   }

    @media screen and (max-width: 981px) {  
        .infoMessage {
            font-size: 3em;            
        }
   }
 
</style>



// WEBPACK FOOTER //
// InfoMessage.vue?77c278a3